import { css } from 'styled-components';
import { mqSmallMin, mqLargeMin } from 'styled/tools/media-queries';

// Dynamic classes are being added from Contentful so these classes are not being used in the codebase,
// but are still popping up in the DOM of our pages

// See node_modules/tachyons-sass/scss/_spacing.scss

export const TachyonsSpacing = ({
  spacingLarge,
  spacingMedium,
  spacingExtraExtraLarge,
}) => css`
  .pa0 {
    padding: 0;
  }
  .pa1 {
    padding: var(--spacing-4);
  }
  .pa2 {
    padding: var(--spacing-8);
  }
  .pa3 {
    padding: ${spacingMedium || 'var(--spacing-24)'};
  }
  .pa4 {
    padding: ${spacingLarge || 'var(--spacing-48)'};
  }
  .pa5 {
    padding: 100px;
  }
  .pa6 {
    padding: ${spacingExtraExtraLarge || '200px'};
  }
  .pa7 {
    padding: 300px;
  }

  .pl0 {
    padding-left: 0;
  }
  .pl1 {
    padding-left: var(--spacing-4);
  }
  .pl2 {
    padding-left: var(--spacing-8);
  }
  .pl3 {
    padding-left: ${spacingMedium || 'var(--spacing-24)'};
  }
  .pl4 {
    padding-left: ${spacingLarge || 'var(--spacing-48)'};
  }
  .pl5 {
    padding-left: 100px;
  }
  .pl6 {
    padding-left: ${spacingExtraExtraLarge || '200px'};
  }
  .pl7 {
    padding-left: 300px;
  }

  .pr0 {
    padding-right: 0;
  }
  .pr1 {
    padding-right: var(--spacing-4);
  }
  .pr2 {
    padding-right: var(--spacing-8);
  }
  .pr3 {
    padding-right: ${spacingMedium || 'var(--spacing-24)'};
  }
  .pr4 {
    padding-right: ${spacingLarge || 'var(--spacing-48)'};
  }
  .pr5 {
    padding-right: 100px;
  }
  .pr6 {
    padding-right: ${spacingExtraExtraLarge || '200px'};
  }
  .pr7 {
    padding-right: 300px;
  }

  .pb0 {
    padding-bottom: 0;
  }
  .pb1 {
    padding-bottom: var(--spacing-4);
  }
  .pb2 {
    padding-bottom: var(--spacing-8);
  }
  .pb3 {
    padding-bottom: ${spacingMedium || 'var(--spacing-24)'};
  }
  .pb4 {
    padding-bottom: ${spacingLarge || 'var(--spacing-48)'};
  }
  .pb5 {
    padding-bottom: 100px;
  }
  .pb6 {
    padding-bottom: ${spacingExtraExtraLarge || '200px'};
  }
  .pb7 {
    padding-bottom: 300px;
  }

  .pt0 {
    padding-top: 0;
  }
  .pt1 {
    padding-top: var(--spacing-4);
  }
  .pt2 {
    padding-top: var(--spacing-8);
  }
  .pt3 {
    padding-top: ${spacingMedium || 'var(--spacing-24)'};
  }
  .pt4 {
    padding-top: ${spacingLarge || 'var(--spacing-48)'};
  }
  .pt5 {
    padding-top: 100px;
  }
  .pt6 {
    padding-top: ${spacingExtraExtraLarge || '200px'};
  }
  .pt7 {
    padding-top: 300px;
  }

  .pv0 {
    padding-top: 0;
    padding-bottom: 0;
  }
  .pv1 {
    padding-top: var(--spacing-4);
    padding-bottom: var(--spacing-4);
  }
  .pv2 {
    padding-top: var(--spacing-8);
    padding-bottom: var(--spacing-8);
  }
  .pv3 {
    padding-top: ${spacingMedium || 'var(--spacing-24)'};
    padding-bottom: ${spacingMedium || 'var(--spacing-24)'};
  }
  .pv4 {
    padding-top: ${spacingLarge || 'var(--spacing-48)'};
    padding-bottom: ${spacingLarge || 'var(--spacing-48)'};
  }
  .pv5 {
    padding-top: 100px;
    padding-bottom: 100px;
  }
  .pv6 {
    padding-top: ${spacingExtraExtraLarge || '200px'};
    padding-bottom: ${spacingExtraExtraLarge || '200px'};
  }

  .pv7 {
    padding-top: 300px;
    padding-bottom: 300px;
  }

  .ph0 {
    padding-left: 0;
    padding-right: 0;
  }

  .ph1 {
    padding-left: var(--spacing-4);
    padding-right: var(--spacing-4);
  }

  .ph2 {
    padding-left: var(--spacing-8);
    padding-right: var(--spacing-8);
  }

  .ph3 {
    padding-left: ${spacingMedium || 'var(--spacing-24)'};
    padding-right: ${spacingMedium || 'var(--spacing-24)'};
  }

  .ph4 {
    padding-left: ${spacingLarge || 'var(--spacing-48)'};
    padding-right: ${spacingLarge || 'var(--spacing-48)'};
  }

  .ph5 {
    padding-left: 100px;
    padding-right: 100px;
  }

  .ph6 {
    padding-left: ${spacingExtraExtraLarge || '200px'};
    padding-right: ${spacingExtraExtraLarge || '200px'};
  }

  .ph7 {
    padding-left: 300px;
    padding-right: 300px;
  }

  .ma0 {
    margin: 0;
  }
  .ma1 {
    margin: var(--spacing-4);
  }
  .ma2 {
    margin: var(--spacing-8);
  }
  .ma3 {
    margin: ${spacingMedium || 'var(--spacing-24)'};
  }
  .ma4 {
    margin: ${spacingLarge || 'var(--spacing-48)'};
  }
  .ma5 {
    margin: 100px;
  }
  .ma6 {
    margin: ${spacingExtraExtraLarge || '200px'};
  }
  .ma7 {
    margin: 300px;
  }

  .ml0 {
    margin-left: 0;
  }
  .ml1 {
    margin-left: var(--spacing-4);
  }
  .ml2 {
    margin-left: var(--spacing-8);
  }
  .ml3 {
    margin-left: ${spacingMedium || 'var(--spacing-24)'};
  }
  .ml4 {
    margin-left: ${spacingLarge || 'var(--spacing-48)'};
  }
  .ml5 {
    margin-left: 100px;
  }
  .ml6 {
    margin-left: ${spacingExtraExtraLarge || '200px'};
  }
  .ml7 {
    margin-left: 300px;
  }

  .mr0 {
    margin-right: 0;
  }
  .mr1 {
    margin-right: var(--spacing-4);
  }
  .mr2 {
    margin-right: var(--spacing-8);
  }
  .mr3 {
    margin-right: ${spacingMedium || 'var(--spacing-24)'};
  }
  .mr4 {
    margin-right: ${spacingLarge || 'var(--spacing-48)'};
  }
  .mr5 {
    margin-right: 100px;
  }
  .mr6 {
    margin-right: ${spacingExtraExtraLarge || '200px'};
  }
  .mr7 {
    margin-right: 300px;
  }

  .mb0 {
    margin-bottom: 0;
  }
  .mb1 {
    margin-bottom: var(--spacing-4);
  }
  .mb2 {
    margin-bottom: var(--spacing-8);
  }
  .mb3 {
    margin-bottom: ${spacingMedium || 'var(--spacing-24)'};
  }
  .mb4 {
    margin-bottom: ${spacingLarge || 'var(--spacing-48)'};
  }
  .mb5 {
    margin-bottom: 100px;
  }
  .mb6 {
    margin-bottom: ${spacingExtraExtraLarge || '200px'};
  }
  .mb7 {
    margin-bottom: 300px;
  }

  .mt0 {
    margin-top: 0;
  }
  .mt1 {
    margin-top: var(--spacing-4);
  }
  .mt2 {
    margin-top: var(--spacing-8);
  }
  .mt3 {
    margin-top: ${spacingMedium || 'var(--spacing-24)'};
  }
  .mt4 {
    margin-top: ${spacingLarge || 'var(--spacing-48)'};
  }
  .mt5 {
    margin-top: 100px;
  }
  .mt6 {
    margin-top: ${spacingExtraExtraLarge || '200px'};
  }
  .mt7 {
    margin-top: 300px;
  }

  .mv0 {
    margin-top: 0;
    margin-bottom: 0;
  }
  .mv1 {
    margin-top: var(--spacing-4);
    margin-bottom: var(--spacing-4);
  }
  .mv2 {
    margin-top: var(--spacing-8);
    margin-bottom: var(--spacing-8);
  }
  .mv3 {
    margin-top: ${spacingMedium || 'var(--spacing-24)'};
    margin-bottom: ${spacingMedium || 'var(--spacing-24)'};
  }
  .mv4 {
    margin-top: ${spacingLarge || 'var(--spacing-48)'};
    margin-bottom: ${spacingLarge || 'var(--spacing-48)'};
  }
  .mv5 {
    margin-top: 100px;
    margin-bottom: 100px;
  }
  .mv6 {
    margin-top: ${spacingExtraExtraLarge || '200px'};
    margin-bottom: ${spacingExtraExtraLarge || '200px'};
  }
  .mv7 {
    margin-top: 300px;
    margin-bottom: 300px;
  }

  .mh0 {
    margin-left: 0;
    margin-right: 0;
  }
  .mh1 {
    margin-left: var(--spacing-4);
    margin-right: var(--spacing-4);
  }
  .mh2 {
    margin-left: var(--spacing-8);
    margin-right: var(--spacing-8);
  }
  .mh3 {
    margin-left: ${spacingMedium || 'var(--spacing-24)'};
    margin-right: ${spacingMedium || 'var(--spacing-24)'};
  }
  .mh4 {
    margin-left: ${spacingLarge || 'var(--spacing-48)'};
    margin-right: ${spacingLarge || 'var(--spacing-48)'};
  }
  .mh5 {
    margin-left: 100px;
    margin-right: 100px;
  }
  .mh6 {
    margin-left: ${spacingExtraExtraLarge || '200px'};
    margin-right: ${spacingExtraExtraLarge || '200px'};
  }
  .mh7 {
    margin-left: 300px;
    margin-right: 300px;
  }

  @media ${mqSmallMin} {
    .pa0-ns {
      padding: 0;
    }
    .pa1-ns {
      padding: var(--spacing-4);
    }
    .pa2-ns {
      padding: var(--spacing-8);
    }
    .pa3-ns {
      padding: ${spacingMedium || 'var(--spacing-24)'};
    }
    .pa4-ns {
      padding: ${spacingLarge || 'var(--spacing-48)'};
    }
    .pa5-ns {
      padding: 100px;
    }
    .pa6-ns {
      padding: ${spacingExtraExtraLarge || '200px'};
    }
    .pa7-ns {
      padding: 300px;
    }

    .pl0-ns {
      padding-left: 0;
    }
    .pl1-ns {
      padding-left: var(--spacing-4);
    }
    .pl2-ns {
      padding-left: var(--spacing-8);
    }
    .pl3-ns {
      padding-left: ${spacingMedium || 'var(--spacing-24)'};
    }
    .pl4-ns {
      padding-left: ${spacingLarge || 'var(--spacing-48)'};
    }
    .pl5-ns {
      padding-left: 100px;
    }
    .pl6-ns {
      padding-left: ${spacingExtraExtraLarge || '200px'};
    }
    .pl7-ns {
      padding-left: 300px;
    }

    .pr0-ns {
      padding-right: 0;
    }
    .pr1-ns {
      padding-right: var(--spacing-4);
    }
    .pr2-ns {
      padding-right: var(--spacing-8);
    }
    .pr3-ns {
      padding-right: ${spacingMedium || 'var(--spacing-24)'};
    }
    .pr4-ns {
      padding-right: ${spacingLarge || 'var(--spacing-48)'};
    }
    .pr5-ns {
      padding-right: 100px;
    }
    .pr6-ns {
      padding-right: ${spacingExtraExtraLarge || '200px'};
    }
    .pr7-ns {
      padding-right: 300px;
    }

    .pb0-ns {
      padding-bottom: 0;
    }
    .pb1-ns {
      padding-bottom: var(--spacing-4);
    }
    .pb2-ns {
      padding-bottom: var(--spacing-8);
    }
    .pb3-ns {
      padding-bottom: ${spacingMedium || 'var(--spacing-24)'};
    }
    .pb4-ns {
      padding-bottom: ${spacingLarge || 'var(--spacing-48)'};
    }
    .pb5-ns {
      padding-bottom: 100px;
    }
    .pb6-ns {
      padding-bottom: ${spacingExtraExtraLarge || '200px'};
    }
    .pb7-ns {
      padding-bottom: 300px;
    }

    .pt0-ns {
      padding-top: 0;
    }
    .pt1-ns {
      padding-top: var(--spacing-4);
    }
    .pt2-ns {
      padding-top: var(--spacing-8);
    }
    .pt3-ns {
      padding-top: ${spacingMedium || 'var(--spacing-24)'};
    }
    .pt4-ns {
      padding-top: ${spacingLarge || 'var(--spacing-48)'};
    }
    .pt5-ns {
      padding-top: 100px;
    }
    .pt6-ns {
      padding-top: ${spacingExtraExtraLarge || '200px'};
    }
    .pt7-ns {
      padding-top: 300px;
    }

    .pv0-ns {
      padding-top: 0;
      padding-bottom: 0;
    }
    .pv1-ns {
      padding-top: var(--spacing-4);
      padding-bottom: var(--spacing-4);
    }
    .pv2-ns {
      padding-top: var(--spacing-8);
      padding-bottom: var(--spacing-8);
    }
    .pv3-ns {
      padding-top: ${spacingMedium || 'var(--spacing-24)'};
      padding-bottom: ${spacingMedium || 'var(--spacing-24)'};
    }
    .pv4-ns {
      padding-top: ${spacingLarge || 'var(--spacing-48)'};
      padding-bottom: ${spacingLarge || 'var(--spacing-48)'};
    }
    .pv5-ns {
      padding-top: 100px;
      padding-bottom: 100px;
    }
    .pv6-ns {
      padding-top: ${spacingExtraExtraLarge || '200px'};
      padding-bottom: ${spacingExtraExtraLarge || '200px'};
    }
    .pv7-ns {
      padding-top: 300px;
      padding-bottom: 300px;
    }
    .ph0-ns {
      padding-left: 0;
      padding-right: 0;
    }
    .ph1-ns {
      padding-left: var(--spacing-4);
      padding-right: var(--spacing-4);
    }
    .ph2-ns {
      padding-left: var(--spacing-8);
      padding-right: var(--spacing-8);
    }
    .ph3-ns {
      padding-left: ${spacingMedium || 'var(--spacing-24)'};
      padding-right: ${spacingMedium || 'var(--spacing-24)'};
    }
    .ph4-ns {
      padding-left: ${spacingLarge || 'var(--spacing-48)'};
      padding-right: ${spacingLarge || 'var(--spacing-48)'};
    }
    .ph5-ns {
      padding-left: 100px;
      padding-right: 100px;
    }
    .ph6-ns {
      padding-left: ${spacingExtraExtraLarge || '200px'};
      padding-right: ${spacingExtraExtraLarge || '200px'};
    }
    .ph7-ns {
      padding-left: 300px;
      padding-right: 300px;
    }

    .ma0-ns {
      margin: 0;
    }
    .ma1-ns {
      margin: var(--spacing-4);
    }
    .ma2-ns {
      margin: var(--spacing-8);
    }
    .ma3-ns {
      margin: ${spacingMedium || 'var(--spacing-24)'};
    }
    .ma4-ns {
      margin: ${spacingLarge || 'var(--spacing-48)'};
    }
    .ma5-ns {
      margin: 100px;
    }
    .ma6-ns {
      margin: ${spacingExtraExtraLarge || '200px'};
    }
    .ma7-ns {
      margin: 300px;
    }

    .ml0-ns {
      margin-left: 0;
    }
    .ml1-ns {
      margin-left: var(--spacing-4);
    }
    .ml2-ns {
      margin-left: var(--spacing-8);
    }
    .ml3-ns {
      margin-left: ${spacingMedium || 'var(--spacing-24)'};
    }
    .ml4-ns {
      margin-left: ${spacingLarge || 'var(--spacing-48)'};
    }
    .ml5-ns {
      margin-left: 100px;
    }
    .ml6-ns {
      margin-left: ${spacingExtraExtraLarge || '200px'};
    }
    .ml7-ns {
      margin-left: 300px;
    }

    .mr0-ns {
      margin-right: 0;
    }
    .mr1-ns {
      margin-right: var(--spacing-4);
    }
    .mr2-ns {
      margin-right: var(--spacing-8);
    }
    .mr3-ns {
      margin-right: ${spacingMedium || 'var(--spacing-24)'};
    }
    .mr4-ns {
      margin-right: ${spacingLarge || 'var(--spacing-48)'};
    }
    .mr5-ns {
      margin-right: 100px;
    }
    .mr6-ns {
      margin-right: ${spacingExtraExtraLarge || '200px'};
    }
    .mr7-ns {
      margin-right: 300px;
    }

    .mb0-ns {
      margin-bottom: 0;
    }
    .mb1-ns {
      margin-bottom: var(--spacing-4);
    }
    .mb2-ns {
      margin-bottom: var(--spacing-8);
    }
    .mb3-ns {
      margin-bottom: ${spacingMedium || 'var(--spacing-24)'};
    }
    .mb4-ns {
      margin-bottom: ${spacingLarge || 'var(--spacing-48)'};
    }
    .mb5-ns {
      margin-bottom: 100px;
    }
    .mb6-ns {
      margin-bottom: ${spacingExtraExtraLarge || '200px'};
    }
    .mb7-ns {
      margin-bottom: 300px;
    }

    .mt0-ns {
      margin-top: 0;
    }
    .mt1-ns {
      margin-top: var(--spacing-4);
    }
    .mt2-ns {
      margin-top: var(--spacing-8);
    }
    .mt3-ns {
      margin-top: ${spacingMedium || 'var(--spacing-24)'};
    }
    .mt4-ns {
      margin-top: ${spacingLarge || 'var(--spacing-48)'};
    }
    .mt5-ns {
      margin-top: 100px;
    }
    .mt6-ns {
      margin-top: ${spacingExtraExtraLarge || '200px'};
    }
    .mt7-ns {
      margin-top: 300px;
    }

    .mv0-ns {
      margin-top: 0;
      margin-bottom: 0;
    }
    .mv1-ns {
      margin-top: var(--spacing-4);
      margin-bottom: var(--spacing-4);
    }
    .mv2-ns {
      margin-top: var(--spacing-8);
      margin-bottom: var(--spacing-8);
    }
    .mv3-ns {
      margin-top: ${spacingMedium || 'var(--spacing-24)'};
      margin-bottom: ${spacingMedium || 'var(--spacing-24)'};
    }
    .mv4-ns {
      margin-top: ${spacingLarge || 'var(--spacing-48)'};
      margin-bottom: ${spacingLarge || 'var(--spacing-48)'};
    }
    .mv5-ns {
      margin-top: 100px;
      margin-bottom: 100px;
    }
    .mv6-ns {
      margin-top: ${spacingExtraExtraLarge || '200px'};
      margin-bottom: ${spacingExtraExtraLarge || '200px'};
    }
    .mv7-ns {
      margin-top: 300px;
      margin-bottom: 300px;
    }

    .mh0-ns {
      margin-left: 0;
      margin-right: 0;
    }
    .mh1-ns {
      margin-left: var(--spacing-4);
      margin-right: var(--spacing-4);
    }
    .mh2-ns {
      margin-left: var(--spacing-8);
      margin-right: var(--spacing-8);
    }
    .mh3-ns {
      margin-left: ${spacingMedium || 'var(--spacing-24)'};
      margin-right: ${spacingMedium || 'var(--spacing-24)'};
    }
    .mh4-ns {
      margin-left: ${spacingLarge || 'var(--spacing-48)'};
      margin-right: ${spacingLarge || 'var(--spacing-48)'};
    }
    .mh5-ns {
      margin-left: 100px;
      margin-right: 100px;
    }
    .mh6-ns {
      margin-left: ${spacingExtraExtraLarge || '200px'};
      margin-right: ${spacingExtraExtraLarge || '200px'};
    }
    .mh7-ns {
      margin-left: 300px;
      margin-right: 300px;
    }
  }

  @media ${mqSmallMin} {
    .pa0-m {
      padding: 0;
    }
    .pa1-m {
      padding: var(--spacing-4);
    }
    .pa2-m {
      padding: var(--spacing-8);
    }
    .pa3-m {
      padding: ${spacingMedium || 'var(--spacing-24)'};
    }
    .pa4-m {
      padding: ${spacingLarge || 'var(--spacing-48)'};
    }
    .pa5-m {
      padding: 100px;
    }
    .pa6-m {
      padding: ${spacingExtraExtraLarge || '200px'};
    }
    .pa7-m {
      padding: 300px;
    }

    .pl0-m {
      padding-left: 0;
    }
    .pl1-m {
      padding-left: var(--spacing-4);
    }
    .pl2-m {
      padding-left: var(--spacing-8);
    }
    .pl3-m {
      padding-left: ${spacingMedium || 'var(--spacing-24)'};
    }
    .pl4-m {
      padding-left: ${spacingLarge || 'var(--spacing-48)'};
    }
    .pl5-m {
      padding-left: 100px;
    }
    .pl6-m {
      padding-left: ${spacingExtraExtraLarge || '200px'};
    }
    .pl7-m {
      padding-left: 300px;
    }

    .pr0-m {
      padding-right: 0;
    }
    .pr1-m {
      padding-right: var(--spacing-4);
    }
    .pr2-m {
      padding-right: var(--spacing-8);
    }
    .pr3-m {
      padding-right: ${spacingMedium || 'var(--spacing-24)'};
    }
    .pr4-m {
      padding-right: ${spacingLarge || 'var(--spacing-48)'};
    }
    .pr5-m {
      padding-right: 100px;
    }
    .pr6-m {
      padding-right: ${spacingExtraExtraLarge || '200px'};
    }
    .pr7-m {
      padding-right: 300px;
    }

    .pb0-m {
      padding-bottom: 0;
    }
    .pb1-m {
      padding-bottom: var(--spacing-4);
    }
    .pb2-m {
      padding-bottom: var(--spacing-8);
    }
    .pb3-m {
      padding-bottom: ${spacingMedium || 'var(--spacing-24)'};
    }
    .pb4-m {
      padding-bottom: ${spacingLarge || 'var(--spacing-48)'};
    }
    .pb5-m {
      padding-bottom: 100px;
    }
    .pb6-m {
      padding-bottom: ${spacingExtraExtraLarge || '200px'};
    }
    .pb7-m {
      padding-bottom: 300px;
    }

    .pt0-m {
      padding-top: 0;
    }
    .pt1-m {
      padding-top: var(--spacing-4);
    }
    .pt2-m {
      padding-top: var(--spacing-8);
    }
    .pt3-m {
      padding-top: ${spacingMedium || 'var(--spacing-24)'};
    }
    .pt4-m {
      padding-top: ${spacingLarge || 'var(--spacing-48)'};
    }
    .pt5-m {
      padding-top: 100px;
    }
    .pt6-m {
      padding-top: ${spacingExtraExtraLarge || '200px'};
    }
    .pt7-m {
      padding-top: 300px;
    }

    .pv0-m {
      padding-top: 0;
      padding-bottom: 0;
    }
    .pv1-m {
      padding-top: var(--spacing-4);
      padding-bottom: var(--spacing-4);
    }
    .pv2-m {
      padding-top: var(--spacing-8);
      padding-bottom: var(--spacing-8);
    }
    .pv3-m {
      padding-top: ${spacingMedium || 'var(--spacing-24)'};
      padding-bottom: ${spacingMedium || 'var(--spacing-24)'};
    }
    .pv4-m {
      padding-top: ${spacingLarge || 'var(--spacing-48)'};
      padding-bottom: ${spacingLarge || 'var(--spacing-48)'};
    }
    .pv5-m {
      padding-top: 100px;
      padding-bottom: 100px;
    }
    .pv6-m {
      padding-top: ${spacingExtraExtraLarge || '200px'};
      padding-bottom: ${spacingExtraExtraLarge || '200px'};
    }
    .pv7-m {
      padding-top: 300px;
      padding-bottom: 300px;
    }

    .ph0-m {
      padding-left: 0;
      padding-right: 0;
    }
    .ph1-m {
      padding-left: var(--spacing-4);
      padding-right: var(--spacing-4);
    }
    .ph2-m {
      padding-left: var(--spacing-8);
      padding-right: var(--spacing-8);
    }
    .ph3-m {
      padding-left: ${spacingMedium || 'var(--spacing-24)'};
      padding-right: ${spacingMedium || 'var(--spacing-24)'};
    }
    .ph4-m {
      padding-left: ${spacingLarge || 'var(--spacing-48)'};
      padding-right: ${spacingLarge || 'var(--spacing-48)'};
    }
    .ph5-m {
      padding-left: 100px;
      padding-right: 100px;
    }
    .ph6-m {
      padding-left: ${spacingExtraExtraLarge || '200px'};
      padding-right: ${spacingExtraExtraLarge || '200px'};
    }
    .ph7-m {
      padding-left: 300px;
      padding-right: 300px;
    }

    .ma0-m {
      margin: 0;
    }
    .ma1-m {
      margin: var(--spacing-4);
    }
    .ma2-m {
      margin: var(--spacing-8);
    }
    .ma3-m {
      margin: ${spacingMedium || 'var(--spacing-24)'};
    }
    .ma4-m {
      margin: ${spacingLarge || 'var(--spacing-48)'};
    }
    .ma5-m {
      margin: 100px;
    }
    .ma6-m {
      margin: ${spacingExtraExtraLarge || '200px'};
    }
    .ma7-m {
      margin: 300px;
    }

    .ml0-m {
      margin-left: 0;
    }
    .ml1-m {
      margin-left: var(--spacing-4);
    }
    .ml2-m {
      margin-left: var(--spacing-8);
    }
    .ml3-m {
      margin-left: ${spacingMedium || 'var(--spacing-24)'};
    }
    .ml4-m {
      margin-left: ${spacingLarge || 'var(--spacing-48)'};
    }
    .ml5-m {
      margin-left: 100px;
    }
    .ml6-m {
      margin-left: ${spacingExtraExtraLarge || '200px'};
    }
    .ml7-m {
      margin-left: 300px;
    }

    .mr0-m {
      margin-right: 0;
    }
    .mr1-m {
      margin-right: var(--spacing-4);
    }
    .mr2-m {
      margin-right: var(--spacing-8);
    }
    .mr3-m {
      margin-right: ${spacingMedium || 'var(--spacing-24)'};
    }
    .mr4-m {
      margin-right: ${spacingLarge || 'var(--spacing-48)'};
    }
    .mr5-m {
      margin-right: 100px;
    }
    .mr6-m {
      margin-right: ${spacingExtraExtraLarge || '200px'};
    }
    .mr7-m {
      margin-right: 300px;
    }

    .mb0-m {
      margin-bottom: 0;
    }
    .mb1-m {
      margin-bottom: var(--spacing-4);
    }
    .mb2-m {
      margin-bottom: var(--spacing-8);
    }
    .mb3-m {
      margin-bottom: ${spacingMedium || 'var(--spacing-24)'};
    }
    .mb4-m {
      margin-bottom: ${spacingLarge || 'var(--spacing-48)'};
    }
    .mb5-m {
      margin-bottom: 100px;
    }
    .mb6-m {
      margin-bottom: ${spacingExtraExtraLarge || '200px'};
    }
    .mb7-m {
      margin-bottom: 300px;
    }

    .mt0-m {
      margin-top: 0;
    }
    .mt1-m {
      margin-top: var(--spacing-4);
    }
    .mt2-m {
      margin-top: var(--spacing-8);
    }
    .mt3-m {
      margin-top: ${spacingMedium || 'var(--spacing-24)'};
    }
    .mt4-m {
      margin-top: ${spacingLarge || 'var(--spacing-48)'};
    }
    .mt5-m {
      margin-top: 100px;
    }
    .mt6-m {
      margin-top: ${spacingExtraExtraLarge || '200px'};
    }
    .mt7-m {
      margin-top: 300px;
    }

    .mv0-m {
      margin-top: 0;
      margin-bottom: 0;
    }
    .mv1-m {
      margin-top: var(--spacing-4);
      margin-bottom: var(--spacing-4);
    }
    .mv2-m {
      margin-top: var(--spacing-8);
      margin-bottom: var(--spacing-8);
    }
    .mv3-m {
      margin-top: ${spacingMedium || 'var(--spacing-24)'};
      margin-bottom: ${spacingMedium || 'var(--spacing-24)'};
    }
    .mv4-m {
      margin-top: ${spacingLarge || 'var(--spacing-48)'};
      margin-bottom: ${spacingLarge || 'var(--spacing-48)'};
    }
    .mv5-m {
      margin-top: 100px;
      margin-bottom: 100px;
    }
    .mv6-m {
      margin-top: ${spacingExtraExtraLarge || '200px'};
      margin-bottom: ${spacingExtraExtraLarge || '200px'};
    }
    .mv7-m {
      margin-top: 300px;
      margin-bottom: 300px;
    }

    .mh0-m {
      margin-left: 0;
      margin-right: 0;
    }
    .mh1-m {
      margin-left: var(--spacing-4);
      margin-right: var(--spacing-4);
    }
    .mh2-m {
      margin-left: var(--spacing-8);
      margin-right: var(--spacing-8);
    }
    .mh3-m {
      margin-left: ${spacingMedium || 'var(--spacing-24)'};
      margin-right: ${spacingMedium || 'var(--spacing-24)'};
    }
    .mh4-m {
      margin-left: ${spacingLarge || 'var(--spacing-48)'};
      margin-right: ${spacingLarge || 'var(--spacing-48)'};
    }
    .mh5-m {
      margin-left: 100px;
      margin-right: 100px;
    }
    .mh6-m {
      margin-left: ${spacingExtraExtraLarge || '200px'};
      margin-right: ${spacingExtraExtraLarge || '200px'};
    }
    .mh7-m {
      margin-left: 300px;
      margin-right: 300px;
    }
  }

  @media ${mqLargeMin} {
    .pa0-l {
      padding: 0;
    }
    .pa1-l {
      padding: var(--spacing-4);
    }
    .pa2-l {
      padding: var(--spacing-8);
    }
    .pa3-l {
      padding: ${spacingMedium || 'var(--spacing-24)'};
    }
    .pa4-l {
      padding: ${spacingLarge || 'var(--spacing-48)'};
    }
    .pa5-l {
      padding: 100px;
    }
    .pa6-l {
      padding: ${spacingExtraExtraLarge || '200px'};
    }
    .pa7-l {
      padding: 300px;
    }

    .pl0-l {
      padding-left: 0;
    }
    .pl1-l {
      padding-left: var(--spacing-4);
    }
    .pl2-l {
      padding-left: var(--spacing-8);
    }
    .pl3-l {
      padding-left: ${spacingMedium || 'var(--spacing-24)'};
    }
    .pl4-l {
      padding-left: ${spacingLarge || 'var(--spacing-48)'};
    }
    .pl5-l {
      padding-left: 100px;
    }
    .pl6-l {
      padding-left: ${spacingExtraExtraLarge || '200px'};
    }
    .pl7-l {
      padding-left: 300px;
    }

    .pr0-l {
      padding-right: 0;
    }
    .pr1-l {
      padding-right: var(--spacing-4);
    }
    .pr2-l {
      padding-right: var(--spacing-8);
    }
    .pr3-l {
      padding-right: ${spacingMedium || 'var(--spacing-24)'};
    }
    .pr4-l {
      padding-right: ${spacingLarge || 'var(--spacing-48)'};
    }
    .pr5-l {
      padding-right: 100px;
    }
    .pr6-l {
      padding-right: ${spacingExtraExtraLarge || '200px'};
    }
    .pr7-l {
      padding-right: 300px;
    }

    .pb0-l {
      padding-bottom: 0;
    }
    .pb1-l {
      padding-bottom: var(--spacing-4);
    }
    .pb2-l {
      padding-bottom: var(--spacing-8);
    }
    .pb3-l {
      padding-bottom: ${spacingMedium || 'var(--spacing-24)'};
    }
    .pb4-l {
      padding-bottom: ${spacingLarge || 'var(--spacing-48)'};
    }
    .pb5-l {
      padding-bottom: 100px;
    }
    .pb6-l {
      padding-bottom: ${spacingExtraExtraLarge || '200px'};
    }
    .pb7-l {
      padding-bottom: 300px;
    }

    .pt0-l {
      padding-top: 0;
    }
    .pt1-l {
      padding-top: var(--spacing-4);
    }
    .pt2-l {
      padding-top: var(--spacing-8);
    }
    .pt3-l {
      padding-top: ${spacingMedium || 'var(--spacing-24)'};
    }
    .pt4-l {
      padding-top: ${spacingLarge || 'var(--spacing-48)'};
    }
    .pt5-l {
      padding-top: 100px;
    }
    .pt6-l {
      padding-top: ${spacingExtraExtraLarge || '200px'};
    }
    .pt7-l {
      padding-top: 300px;
    }

    .pv0-l {
      padding-top: 0;
      padding-bottom: 0;
    }
    .pv1-l {
      padding-top: var(--spacing-4);
      padding-bottom: var(--spacing-4);
    }
    .pv2-l {
      padding-top: var(--spacing-8);
      padding-bottom: var(--spacing-8);
    }
    .pv3-l {
      padding-top: ${spacingMedium || 'var(--spacing-24)'};
      padding-bottom: ${spacingMedium || 'var(--spacing-24)'};
    }
    .pv4-l {
      padding-top: ${spacingLarge || 'var(--spacing-48)'};
      padding-bottom: ${spacingLarge || 'var(--spacing-48)'};
    }
    .pv5-l {
      padding-top: 100px;
      padding-bottom: 100px;
    }
    .pv6-l {
      padding-top: ${spacingExtraExtraLarge || '200px'};
      padding-bottom: ${spacingExtraExtraLarge || '200px'};
    }
    .pv7-l {
      padding-top: 300px;
      padding-bottom: 300px;
    }

    .ph0-l {
      padding-left: 0;
      padding-right: 0;
    }
    .ph1-l {
      padding-left: var(--spacing-4);
      padding-right: var(--spacing-4);
    }
    .ph2-l {
      padding-left: var(--spacing-8);
      padding-right: var(--spacing-8);
    }
    .ph3-l {
      padding-left: ${spacingMedium || 'var(--spacing-24)'};
      padding-right: ${spacingMedium || 'var(--spacing-24)'};
    }
    .ph4-l {
      padding-left: ${spacingLarge || 'var(--spacing-48)'};
      padding-right: ${spacingLarge || 'var(--spacing-48)'};
    }
    .ph5-l {
      padding-left: 100px;
      padding-right: 100px;
    }
    .ph6-l {
      padding-left: ${spacingExtraExtraLarge || '200px'};
      padding-right: ${spacingExtraExtraLarge || '200px'};
    }
    .ph7-l {
      padding-left: 300px;
      padding-right: 300px;
    }

    .ma0-l {
      margin: 0;
    }
    .ma1-l {
      margin: var(--spacing-4);
    }
    .ma2-l {
      margin: var(--spacing-8);
    }
    .ma3-l {
      margin: ${spacingMedium || 'var(--spacing-24)'};
    }
    .ma4-l {
      margin: ${spacingLarge || 'var(--spacing-48)'};
    }
    .ma5-l {
      margin: 100px;
    }
    .ma6-l {
      margin: ${spacingExtraExtraLarge || '200px'};
    }
    .ma7-l {
      margin: 300px;
    }

    .ml0-l {
      margin-left: 0;
    }
    .ml1-l {
      margin-left: var(--spacing-4);
    }
    .ml2-l {
      margin-left: var(--spacing-8);
    }
    .ml3-l {
      margin-left: ${spacingMedium || 'var(--spacing-24)'};
    }
    .ml4-l {
      margin-left: ${spacingLarge || 'var(--spacing-48)'};
    }
    .ml5-l {
      margin-left: 100px;
    }
    .ml6-l {
      margin-left: ${spacingExtraExtraLarge || '200px'};
    }
    .ml7-l {
      margin-left: 300px;
    }

    .mr0-l {
      margin-right: 0;
    }
    .mr1-l {
      margin-right: var(--spacing-4);
    }
    .mr2-l {
      margin-right: var(--spacing-8);
    }
    .mr3-l {
      margin-right: ${spacingMedium || 'var(--spacing-24)'};
    }
    .mr4-l {
      margin-right: ${spacingLarge || 'var(--spacing-48)'};
    }
    .mr5-l {
      margin-right: 100px;
    }
    .mr6-l {
      margin-right: ${spacingExtraExtraLarge || '200px'};
    }
    .mr7-l {
      margin-right: 300px;
    }

    .mb0-l {
      margin-bottom: 0;
    }
    .mb1-l {
      margin-bottom: var(--spacing-4);
    }
    .mb2-l {
      margin-bottom: var(--spacing-8);
    }
    .mb3-l {
      margin-bottom: ${spacingMedium || 'var(--spacing-24)'};
    }
    .mb4-l {
      margin-bottom: ${spacingLarge || 'var(--spacing-48)'};
    }
    .mb5-l {
      margin-bottom: 100px;
    }
    .mb6-l {
      margin-bottom: ${spacingExtraExtraLarge || '200px'};
    }
    .mb7-l {
      margin-bottom: 300px;
    }

    .mt0-l {
      margin-top: 0;
    }
    .mt1-l {
      margin-top: var(--spacing-4);
    }
    .mt2-l {
      margin-top: var(--spacing-8);
    }
    .mt3-l {
      margin-top: ${spacingMedium || 'var(--spacing-24)'};
    }
    .mt4-l {
      margin-top: ${spacingLarge || 'var(--spacing-48)'};
    }
    .mt5-l {
      margin-top: 100px;
    }
    .mt6-l {
      margin-top: ${spacingExtraExtraLarge || '200px'};
    }
    .mt7-l {
      margin-top: 300px;
    }

    .mv0-l {
      margin-top: 0;
      margin-bottom: 0;
    }
    .mv1-l {
      margin-top: var(--spacing-4);
      margin-bottom: var(--spacing-4);
    }
    .mv2-l {
      margin-top: var(--spacing-8);
      margin-bottom: var(--spacing-8);
    }
    .mv3-l {
      margin-top: ${spacingMedium || 'var(--spacing-24)'};
      margin-bottom: ${spacingMedium || 'var(--spacing-24)'};
    }
    .mv4-l {
      margin-top: ${spacingLarge || 'var(--spacing-48)'};
      margin-bottom: ${spacingLarge || 'var(--spacing-48)'};
    }
    .mv5-l {
      margin-top: 100px;
      margin-bottom: 100px;
    }
    .mv6-l {
      margin-top: ${spacingExtraExtraLarge || '200px'};
      margin-bottom: ${spacingExtraExtraLarge || '200px'};
    }
    .mv7-l {
      margin-top: 300px;
      margin-bottom: 300px;
    }

    .mh0-l {
      margin-left: 0;
      margin-right: 0;
    }
    .mh1-l {
      margin-left: var(--spacing-4);
      margin-right: var(--spacing-4);
    }
    .mh2-l {
      margin-left: var(--spacing-8);
      margin-right: var(--spacing-8);
    }
    .mh3-l {
      margin-left: ${spacingMedium || 'var(--spacing-24)'};
      margin-right: ${spacingMedium || 'var(--spacing-24)'};
    }
    .mh4-l {
      margin-left: ${spacingLarge || 'var(--spacing-48)'};
      margin-right: ${spacingLarge || 'var(--spacing-48)'};
    }
    .mh5-l {
      margin-left: 100px;
      margin-right: 100px;
    }
    .mh6-l {
      margin-left: ${spacingExtraExtraLarge || '200px'};
      margin-right: ${spacingExtraExtraLarge || '200px'};
    }
    .mh7-l {
      margin-left: 300px;
      margin-right: 300px;
    }
  }
`;
